import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar, Username } from '../components/UserBadge';
import { Calendar, Clock, Crown, Edit3 } from 'lucide-react';
import { format, formatDistanceToNow } from 'date-fns';

export default function StandardProfileHeader({ u, isOwn, setForm, setEditing }) {
  const bgImg = u.banner_url || ((process.env.PUBLIC_URL || "/forum") + "/banners/default_profile_banner.png");
  
  return (
    <div className="bg-[#12161f] border border-white/5 rounded-2xl overflow-hidden shadow-xl mb-6">
      {/* Banner */}
      <div 
        className="h-32 sm:h-48 w-full bg-zinc-800 bg-cover bg-center relative"
        style={{ backgroundImage: `url(${bgImg})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-[#12161f] via-[#12161f]/20 to-transparent" />
      </div>

      {/* Profile Info Section */}
      <div className="px-6 sm:px-8 pb-8 relative -mt-12 sm:-mt-16">
        <div className="flex flex-col sm:flex-row gap-5 items-center sm:items-end text-center sm:text-left">
          
          {/* Avatar */}
          <div className="relative shrink-0">
            <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full border-4 border-[#12161f] overflow-hidden bg-zinc-800 shadow-2xl shadow-black/50">
              <Avatar user={u} className="w-full h-full object-cover" noTooltip />
            </div>
          </div>

          {/* User Info */}
          <div className="flex-1 min-w-0 pb-1 mt-3 sm:mt-0">
            <div className="flex flex-col items-center sm:items-start gap-1">
              <Username user={u} className="text-3xl font-black text-white" asText />
              <div className="flex items-center justify-center sm:justify-start gap-3 flex-wrap mt-1">
                <span className="px-3 py-1 bg-white/5 border border-white/10 rounded-full text-[11px] font-bold text-zinc-300">
                  {u.group_name || "Membru Comunitate"}
                </span>
                {u.last_seen && (
                  <span className="flex items-center gap-1.5 text-xs font-medium text-zinc-400">
                    <Clock className="w-3.5 h-3.5" />
                    Activ(ă) {formatDistanceToNow(new Date(u.last_seen), { addSuffix: true })}
                  </span>
                )}
                {u.joined_at && (
                  <span className="flex items-center gap-1.5 text-xs font-medium text-zinc-400">
                    <Calendar className="w-3.5 h-3.5" />
                    Membru din {format(new Date(u.joined_at), "MMM yyyy")}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-3 pb-2 w-full sm:w-auto justify-center sm:justify-end mt-4 sm:mt-0">
            {isOwn ? (
              <button 
                onClick={() => { setForm(u); setEditing(true); }}
                className="flex items-center justify-center gap-2 px-5 py-2.5 bg-zinc-800 hover:bg-zinc-700 text-white rounded-lg font-bold text-sm transition-colors border border-white/10"
              >
                <Edit3 className="w-4 h-4" />
                Editează Profilul
              </button>
            ) : (
              <div className="flex flex-col items-center sm:items-end gap-2">
                <Link to="/vip" className="px-4 py-1.5 bg-gradient-to-r from-amber-500/20 to-orange-500/20 border border-amber-500/40 hover:bg-amber-500 hover:text-black text-amber-500 text-xs font-black uppercase rounded transition-colors flex items-center gap-1.5">
                  <Crown className="w-3.5 h-3.5" /> Devino VIP
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
